import { useConfiguration } from "./configuration";
import { usePreferences } from "./me";

/**
 * The week start the UI should use for the current user.
 *
 * Composes the user's preference with the tenant's planning week_start:
 *   - user override (1-7) → use it
 *   - user has no override → fall back to tenant Configuration.weekStart
 *   - both queries still pending → return 1 (Monday) as a safe default
 *
 * The tenant Configuration.timezone / week_start primarily drive backend
 * planning math; we reuse week_start as the *display* fallback here so a
 * silent user sees their company's calendar by default.
 */
export function useEffectiveWeekStart(): number {
  const prefs = usePreferences();
  const config = useConfiguration();
  return prefs.data?.displayWeekStart ?? config.data?.weekStart ?? 1;
}
